if (!customElements.get('product-info-tabs')) {
  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.product-info-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll('.product-info-tabs__panel'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
      });
    }

    select(name) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.panel === name);
      });
    }
  }

  customElements.define('product-info-tabs', ProductInfoTabs);
}
